module.exports = __webpack_public_path__ + "school/img/fanfu.73b77313.png";